import { api } from "../constants/Constant";
import { USER_MANAGEMENT } from "./const";

export function deepEqual(a, b) {
    if (a === b) return true;
    if (a === null || b === null) { return false }
    if (typeof a !== 'object' || typeof b !== 'object') return false;

    const keysA = Object.keys(a);
    const keysB = Object.keys(b);

    if (keysA.length !== keysB.length) return false;

    for (let key of keysA) {
        if (!keysB.includes(key)
            || !deepEqual(a[key], b[key])) {
            return false;
        }
    }

    return true;
}

export const formatUserDisplayName = (user) => (
  [user?.firstname, user?.lastname].filter((part) => typeof part === 'string' && part.trim()).join(' ').trim()
);

export const getMaxDate = () => {
    const today = new Date();
    today.setDate(today.getDate());
    return today.toISOString().split("T")[0];
};

export const validateImage = (file) => {
    const errors = {};
    if (file) {
        if (file.size > 2000000) {
            // 2MB
            errors.image = "File too large, maximum size is 2MB";
        }
        if (!["image/jpeg", "image/png"].includes(file.type)) {
            errors.image = "Unsupported File Format. Only JPEG and PNG are allowed";
        }
    }
    return errors;
};

export const getProfileImage = async (fileName, setData) => {
    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `Bearer ${token}`,
      };
      
    if(fileName){
        try {
            fetch(`${api}${USER_MANAGEMENT.GET_PROFILE_PICTURE}${fileName}`, {headers, responseType: 'blob' })
                .then((res) => res.blob())
                .then((blob) => {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        setData(reader.result)
                    };
                    reader.readAsDataURL(blob);
                });
        } catch (err) {
            console.log('Error fetching Profile Photo', err);
        }
    }
}